import { getUploadedImageUrl } from '../../../../api';
import React, { useEffect, useState } from 'react';
import './viewClient.style.scss';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";

const ReadOnlyClientView = ({ client }) => {
     const lineHeight = "35px";
     const navigate = useNavigate();

     const [LGOUser, setLGOUser] = useState([])

     useEffect(() => {
          const userToken = localStorage.getItem("LGOUser");
          if (userToken) {
               try {
                    const decoded = jwtDecode(userToken);
                    const currentTime = Math.floor(Date.now() / 1000);

                    if (decoded.exp && decoded.exp < currentTime) {
                         setLGOUser(decoded);
                         console.log(decoded)
                    } else {
                         // localStorage.removeItem("LGOUser");
                         // navigate("/login");
                    }
               } catch (error) {
                    // localStorage.removeItem("LGOUser");
                    // navigate("/login");
               }
          } else {
               navigate("/login");
          }
          // eslint-disable-next-line
     }, [])

     return (
          <div className="mt-5 rounded rounded-5 col-46 offset-1 p-2 alert-light mt-3">
               {/* <img src="..." className="card-img-top" alt="..."> */}
               <div className="card-body fs-6 mt-3">
                    <div className="col-24 mb-3 offset-12 text-center">
                         <div>
                              {client.logoLink ? (
                                   <img
                                        src={getUploadedImageUrl(client.logoLink)}
                                        alt="Company Logo"
                                        style={{ width: '100%', height: 'auto', maxHeight: "175px", objectFit: 'contain' }}
                                   />
                              ) : (
                                   <svg
                                        width="100%"
                                        height="120"
                                        xmlns="http://www.w3.org/2000/svg"
                                   >
                                        <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="#888" fontSize="12">
                                             Company Logo - Edit Customer to Add Logo
                                        </text>
                                   </svg>
                              )}
                         </div>
                    </div>


                    <div className="d-flex gap-2 align-items-center" style={{ lineHeight }}>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Client:</div>
                              <div>{client.companyName} <span className='fw-bold text-warning'>[{client.theLocation || 'Main'}]</span></div>
                         </div>
                         <div className="col-12 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Phone:</div>
                              <div>{client.phone}</div>
                         </div>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Email:</div>
                              <div>{client.email}</div>
                         </div>
                    </div>

                    <div className="d-flex gap-2 align-items-center" style={{ lineHeight }}>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Address:</div>
                              <div>{client.address}</div>
                         </div>
                         <div className="col-12 d-flex gap-3">
                              <div className="fw-bold text-end col-18">City/Prov:</div>
                              <div>{client.city}, {client.province}</div>
                         </div>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Postal</div>
                              <div>{client.postal}</div>
                         </div>
                    </div>

                    <div className="d-flex gap-2 align-items-center" style={{ lineHeight }}>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Contact Person:</div>
                              <div>{client.companyOwner}</div>
                         </div>
                         <div className="col-12 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Acct. Manager:</div>
                              <div>{client.accountmanager}</div>
                         </div>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Status:</div>
                              <div className={`${client.status === 'Active' ? 'text-success' : 'text-danger'}`}>{client.status}</div>
                         </div>
                    </div>
                    <div className="d-flex gap-2 align-items-center" style={{ lineHeight }}>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Website:</div>
                              <div className='hide_overflow'>{client.website}</div>
                         </div>
                         <div className="col-12 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Primary Cat:</div>
                              <div>{client.primaryCat}</div>
                         </div>
                         <div className="col-18 d-flex gap-3">
                              <div className="fw-bold text-end col-18">Google ID:</div>
                              <div>{client.gmbLink}</div>
                         </div>
                    </div>
                    {/* <div className="alert-navy p-1 mt-2" style={{ lineHeight }}>
                         {LGOUser.security !== 'Admin' && (
                              <>
                                   <div className="text-center fw-8">
                                        The Three Boxes below represent the username and password used to Create the citations.
                                   </div>
                                   <div className="w-100 d-flex gap-2 align-items-center">
                                        <div className="col-18 d-flex gap-3">
                                             <div className="fw-bold text-end col-18">Citation Username:</div>
                                             <div className='hide_overflow'>{client.citationUser}</div>
                                        </div>
                                        <div className="col-12 d-flex gap-3">
                                             <div className="fw-bold text-end col-18">Citation Email:</div>
                                             <div>{client.citationEmail}</div>
                                        </div>
                                        <div className="col-18 d-flex gap-3">
                                             <div className="fw-bold text-end col-18">Citation Pass:</div>
                                             <div>{client.citationPass}</div>
                                        </div>
                                   </div>
                              </>
                         )}

                         <div className="text-center fw-8">The Username and Password are to be given to Client for the Client Facing Boards</div>
                         <div className="w-100 d-flex gap-2 align-items-center justify-content-center">
                              <div className="w-50 d-flex align-items-center">
                                   <div className="col-24 d-flex gap-1 justify-content-center">
                                        <div className="fw-bold text-end col-12">Username:</div>
                                        <div className='hide_overflow col-24 ps-1 text-start'>{client.clientUser}</div>
                                   </div>
                                   <div className="col-24 d-flex gap-1 justify-content-center">
                                        <div className="fw-bold text-start col-12">Password:</div>
                                        <div>{client.clientUserPassword}</div>
                                   </div>
                              </div>
                         </div>
                    </div> */}
                    <div className="p-4">
                         <div className="col-48 fw-bold text-start">Company Description</div>
                         <div className="col-48 d-flex gap-3">
                              <div>{client.description}</div>
                         </div>
                    </div>
                    <div className="alert-secondary rounded rounded-5 p-3">
                         <div className="w-100 text-center fw-bold h6">Information for Citations</div>
                         <div className="d-flex justify-content-between">
                              <div className="col-16 p-3 alert-secondary">
                                   <label>Store Hours</label>
                                   <div className=" p-3">
                                        {Object.entries(client.storeHours).map(([day, times], idx) => (
                                             <div key={idx} className="mb-2">
                                                  <strong className="text-primary">{day}:</strong>{" "}
                                                  {times.opening || "-"} - {times.closing || "-"}
                                             </div>
                                        ))}
                                   </div>
                              </div>
                              <div className="col-16 alert-secondary p-3">
                                   <label>Extra Categories</label>
                                   <ul>
                                        {client.extraBusiness?.map((cat, index) => (
                                             <li key={index}>{cat}</li>
                                        ))}
                                   </ul>
                              </div>
                              <div className="flex-grow-1 alert-secondary p-3">
                                   <label>Extra Services</label>
                                   <ul>
                                        {client.extraBusiness?.map((cat, index) => (
                                             <li key={index}>{cat}</li>
                                        ))}
                                   </ul>
                              </div>
                         </div>
                         <div className="d-flex col-44 offset-2 p-3 gap-3 flex-wrap alert-secondary">
                              {Object.entries(client.socialMedia).map(([platform, { link }], idx) => (
                                   <div key={idx} className='col-22 d-flex'>
                                        <div className="col-18 text-end pe-2 fw-bold">{platform}:</div>
                                        <div className="col-28 text-start">{link || "Not Provided"}</div>
                                   </div>
                              ))}
                         </div>
                    </div>
                    <div className="alert-navy rounded rounded-5 p-3">
                         <div className="text-center w-100 h6">
                              Client Login/Citation Building Information
                         </div>
                         <div className="d-flex w-75 mx-auto justify-content-between gap-2 mt-2">
                              <div className="col-24 text-center p-3">
                                   <div className="w-100 text-center mb-2">Client Facing Portal Log In</div>
                                   <div className="d-flex gap-3 py-">
                                        <div className="col-18 text-end fw-bold text-primary">User Name:</div>
                                        <div className="flex-grow-1 text-start ps-1">{client.clientUser || 'Not Set'}</div>
                                   </div>
                                   <div className="d-flex gap-3 py-1">
                                        <div className="col-18 text-end fw-bold text-primary">Password:</div>
                                        <div className="flex-grow-1 text-start ps-1">{client.clientUserPassword || 'Not Set'}</div>
                                   </div>
                              </div>
                              <div className="col-24  text-center p-3 border-start border-navy border-2">
                              <div className="w-100 text-center mb-2">Citation Creation Information</div>
                                   <div className="d-flex gap-3 py-1">
                                        <div className="col-18 text-end fw-bold text-primary">User Name:</div>
                                        <div className="flex-grow-1 text-start ps-1">{client.citationUser || 'Not Set'}</div>
                                   </div>
                                   <div className="d-flex gap-3 py-1">
                                        <div className="col-18 text-end fw-bold text-primary">Password:</div>
                                        <div className="flex-grow-1 text-start ps-1">{client.citationPass || 'Not Set'}</div>
                                   </div>
                                   <div className="d-flex gap-3 py-1">
                                        <div className="col-18 text-end fw-bold text-primary">email:</div>
                                        <div className="flex-grow-1 text-start ps-1">{client.citationEmail || 'Not Set'}</div>
                                   </div>
                                   <div className="d-flex gap-3 py-1">
                                        <div className="col-18 text-end fw-bold text-primary">email Password:</div>
                                        <div className="flex-grow-1 text-start ps-1">{client.citationPass || 'Not Set'}</div>
                                   </div>
                              </div>
                         </div>

                    </div>
               </div>
          </div>
     );
};

export default ReadOnlyClientView;
